/**
 * Shared timezone list for connector scheduling. Used by both the detail-page
 * Schedule tab and the Add Connector wizard's Schedule step (#273) so the two
 * surfaces offer an identical set of zones.
 */
export const TIMEZONES: ReadonlyArray<readonly [string, string]> = [
  ['America/New_York', 'Eastern Time (US)'],
  ['UTC', 'UTC (Coordinated Universal Time)'],
  ['America/Chicago', 'Central Time (US)'],
  ['America/Denver', 'Mountain Time (US)'],
  ['America/Los_Angeles', 'Pacific Time (US)'],
  ['Europe/London', 'London (GMT/BST)'],
  ['Europe/Paris', 'Paris (CET/CEST)'],
  ['Europe/Berlin', 'Berlin (CET/CEST)'],
  ['Asia/Tokyo', 'Tokyo (JST)'],
  ['Asia/Shanghai', 'Shanghai (CST)'],
  ['Asia/Singapore', 'Singapore (SGT)'],
  ['Australia/Sydney', 'Sydney (AEST/AEDT)'],
] as const;
